exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tooltip-target[data-v-804e69b6] {\n  opacity: .5;\n}\n.tooltip-target[data-v-804e69b6]:hover {\n    opacity: 1;\n}\n.line[data-v-804e69b6] {\n  min-width: 250px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  white-space: nowrap;\n  margin-bottom: 7.5px;\n  font-weight: 600;\n}\n.line .good[data-v-804e69b6] {\n    color: #4CAF50;\n}\n.line .bad[data-v-804e69b6] {\n    color: #FF5252;\n}\n.line.total[data-v-804e69b6] {\n    color: inherit;\n    margin-bottom: 0;\n    font-weight: 700;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-804e69b6","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/elements/BudgetTooltip.vue
// module id = 582
// module chunks = 0